const NatTab = [
    {
        Ind: 1,
        lib: 'Téléphone',
        uri: 'tel:',
        icone: 'fas fa-phone',
    }, // 1
    {
        Ind: 2,
        lib: 'Fax',
        uri: 'tel:',
        icone: 'fas fa-fax',
    }, // 2
    {
        Ind: 3,
        lib: 'Mobile',
        uri: 'tel:',
        icone: 'fas fa-mobile-alt',
    }, // 3
    {
        Ind: 4,
        lib: 'Courriel',
        uri: 'mailto:',
        icone: 'fas fa-envelope',
    }, // 4
    {
        Ind: 5,
        lib: 'Site web',
        uri: '',
        icone: 'fas fa-globe',
    }, // 5
];

function NatContact(nat) {
    const objetNature = NatTab.find(ligne => ligne.Ind === nat);
    return objetNature || { lib: '', uri: '', icone: 'fas fa-address-card' };
}

export default NatContact;
export { NatTab };



// WEBPACK FOOTER //
// ./src/App_Data/NatContact.js